import React, { Component } from "react";
import { Typography, IconButton, Tooltip, ClickAwayListener } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import "./SectionHeader.css";

class SectionHeader extends Component {
    state = {
        open: false
    };

    handleClick = () => {
        this.setState(prevState => ({ open: !prevState.open }));
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { title, helpText, variant = "headline", compact = false } = this.props;
        const { open } = this.state;

        return (
            <div className={`common-section-header ${compact ? 'common-section-header-compact' : ''}`} style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', width: '100%' }}>
                <Typography variant={variant} component="h3" gutterBottom className="common-section-header-title" align="left" style={{ textAlign: 'left', width: '100%' }}>
                    {title}
                    {helpText && (
                        <ClickAwayListener onClickAway={this.handleClose}>
                            <span>
                                <Tooltip
                                    title={helpText}
                                    open={open}
                                    onClose={this.handleClose}
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                    interactive
                                    placement="right"
                                    classes={{
                                        tooltip: "section-help-tooltip"
                                    }}
                                >
                                    <IconButton
                                        className="section-help-icon"
                                        onClick={this.handleClick}
                                        size="small"
                                    >
                                        <HelpOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </span>
                        </ClickAwayListener>
                    )}
                </Typography>
            </div>
        );
    }
}

export default SectionHeader;
